import React, { PropsWithChildren } from "react";
import Sidebar from "../../Sidebar/Sidebar";
import OrderInformation from "../../OrderInformation/OrderInformation";
import WarningList from "../../Sidebar/WarningList/WarningList";
import { Message } from "semantic-ui-react";

type Props = {
  isItemScanned: boolean;
  isAllRestocked: boolean;
  header: string;
  content: string;
} & PropsWithChildren;

const RestockSidebar = ({ isItemScanned, isAllRestocked, header, content, children }: Props) => {
  return (
    <Sidebar show>
      <OrderInformation />
      <WarningList />
      <Message
        icon={isAllRestocked ? "check" : "exclamation"}
        negative
        size="big"
        color={isAllRestocked ? "green" : isItemScanned ? "blue" : undefined}
        header={header}
        content={content}
      />
      {children}
    </Sidebar>
  );
};

export default RestockSidebar;
